import {
  ControlModeTypes,
  TransformControlModeTypes,
  TransformControlsSpaceTypes
} from '@/services/constants';

const state = {
  // Loading flags
  bootstrapComplete: false, // True once the scene is completely setup
  skyBoxLoaded: false,
  figureLoaded: false,
  floorMarkerLoaded: false,
  // Navigation and control modes
  navigationLocked: false,
  controlMode: ControlModeTypes.DEFAULT,
  transformControlsMode: TransformControlModeTypes.TRANSLATE,
  transformControlsSpace: TransformControlsSpaceTypes.WORLD,
  transformControlsLocked: false,
  transformControlsSnapping: false,
  // Element Selection
  selectedElements: [],
  hoveredElement: null,
  metaMode: false,
};

const getters = {
  staticAssetsLoaded(state) {
    return state.skyBoxLoaded && state.figureLoaded && state.floorMarkerLoaded;
  }
};

const mutations = {
  SET_BOOTSTRAP_COMPLETE(state, payload) {
    state.bootstrapComplete = payload.bootstrapComplete;
  },
  SET_LOADED_FLAG(state, payload) {
    if (payload.skyBoxLoaded) state.skyBoxLoaded = payload.skyBoxLoaded;
    if (payload.figureLoaded) state.figureLoaded = payload.figureLoaded;
    if (payload.floorMarkerLoaded) state.floorMarkerLoaded = payload.floorMarkerLoaded;
  },
  SET_SELECTED_ELEMENTS(state, { selectedElements }) {
    state.selectedElements = selectedElements;
  },
  SET_HOVERED_ELEMENT(state, { hoveredElement }) {
    state.hoveredElement = hoveredElement;
  },
  SET_CONTROL_MODE(state, { controlMode }) {
    state.controlMode = controlMode;
  },
  SET_CAMERA_MODE(state, { cameraMode }) {
    state.cameraMode = cameraMode;
  },
  SET_META_MODE(state, { metaMode }) {
    state.metaMode = metaMode;
  },
  SET_TRANSFORM_CONTROLS_MODE(state, { transformControlsMode }) {
    state.transformControlsMode = transformControlsMode;
  },
  SET_TRANSFORM_CONTROLS_SPACE(state, { transformControlsSpace }) {
    state.transformControlsSpace = transformControlsSpace;
  },
  SET_TRANSFORM_CONTROLS_SNAPPING(state, { transformControlsSnapping }) {
    state.transformControlsSnapping = transformControlsSnapping;
  },
  LOCK_NAVIGATION() {
    state.navigationLocked = true;
  },
  UNLOCK_NAVIGATION() {
    state.navigationLocked = false;
  },
  LOCK_TRANSFORM_CONTROLS() {
    state.transformControlsLocked = true;
  },
  UNLOCK_TRANSFORM_CONTROLS() {
    state.transformControlsLocked = false;
  },
};

const actions = {
  cleanup({ commit }) {
    commit('SET_BOOTSTRAP_COMPLETE', {
      bootstrapComplete: false,
    });
    commit('SET_LOADED_FLAG', {
      skyBoxLoaded: false,
      figureLoaded: false,
      floorMarkerLoaded: false,
    });
    commit('SET_TRANSFORM_CONTROLS_SPACE', {
      transformControlsSpace: TransformControlsSpaceTypes.WORLD,
    });
    commit('SET_TRANSFORM_CONTROLS_MODE', {
      transformControlsMode: TransformControlModeTypes.TRANSLATE
    });
    commit('SET_SELECTED_ELEMENTS', {
      selectedElements: [],
    });
  },
  setTransformControlsSpace({ commit }, space) {
    commit('SET_TRANSFORM_CONTROLS_SPACE', {
      transformControlsSpace: space
    });
  },
  setTransformControlsMode({ commit }, mode) {
    commit('SET_TRANSFORM_CONTROLS_MODE', {
      transformControlsMode: mode
    });
  },
  setTransformControlsSnapping({ commit }, snapping) {
    commit('SET_TRANSFORM_CONTROLS_SNAPPING', {
      transformControlsSnapping: snapping
    });
  },
  safelyUnsetHoveredElement({ commit }, payload) {
    if (state.hoveredElement === payload.hoveredElement) {
      commit('SET_HOVERED_ELEMENT', { hoveredElement: null });
    }
  },
  unselectAll({ commit }) {
    console.warn('unselect all');
    commit('SET_SELECTED_ELEMENTS', { selectedElements: [] });
    commit('SET_HOVERED_ELEMENT', { hoveredElement: null });
  },
  selectElement({ commit }, payload) {
    console.log(`Panels Editor: Setting selected elements to ${payload.selectedElement}`);
    commit('SET_SELECTED_ELEMENTS', {
      selectedElements: [payload.selectedElement]
    });
    commit('SET_HOVERED_ELEMENT', { hoveredElement: null });
  },
  addElementToSelection({ commit }, payload) {
    if (!state.selectedElements.includes(payload.selectedElement)) {
      commit('SET_SELECTED_ELEMENTS', {
        selectedElements: [...state.selectedElements, payload.selectedElement]
      });
    }
  },
  removeElementFromSelection({ commit }, payload) {
    if (state.selectedElements.includes(payload.selectedElement)) {
      commit('SET_SELECTED_ELEMENTS', {
        selectedElements: state.selectedElements.filter(
          el => el !== payload.selectedElement
        )
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
